// extracted by mini-css-extract-plugin
export default {"reactSlidedown":"slideUpDown_reactSlidedown__wast4","transitioning":"slideUpDown_transitioning__pHNim","closed":"slideUpDown_closed__CLEHy"};